export default __webpack_public_path__ + "static/media/mute.bba0b4b5.svg";